import ReactPlayer from 'react-player'
import { externalLink, GitHub, internalLink } from '../DataAndAPIs/Links'

export const tutorialRouter = (route) => {
	const tutorial = tutorialList.find(t => t.route === route)

	if (!tutorial) {
		console.warn(`Tutorial route '${route}' not found`)
		return tutorialIndexRender()
	}

	return tutorial.render()
}

const tutorialRoutePrefix = '/tutorial/'

const tutorialIndexRender = () => {
	return ( <div>
		<h4>Available Tutorials</h4>
		<p>Click on any tutorial below to begin:</p>
		<ul>
			{tutorialList.map((tutorial, index) => (
				<li key={index}><a href={`${tutorialRoutePrefix}${tutorial.route}`}>{tutorial.name}</a></li>
			))}
		</ul>
	</div> )
}
const tutorialIndex	 = { 'name':'Tutorial Index', 'route':'index', 'render':tutorialIndexRender } 


// Tutorial 001: Tools of the Trade with Chocolatey
const toolsOfTheTradeWithChocolateyName = 'Tools of the Trade with Chocolatey' 
const toolsOfTheTradeWithChocolateyRoute = 'tools-of-the-trade-with-chocolatey'

// const toolsOfTheTradeWithChocolateyVideoURL = 'https://pithub.blob.core.windows.net/nvm4zqwm/1j7x0g3k-tools-of-the-trade-with-chocolatey.mp4'

export const toolsOfTheTradeWithChocolateyRender = () => {
	const chocolatey = () => { return externalLink('Chocolatey', 'https://chocolatey.org/') }
	const chocolateyPackages = () => { return externalLink('Chocolatey Packages', 'https://community.chocolatey.org/packages') }

	return ( <div>
		<h4>{toolsOfTheTradeWithChocolateyName}</h4>
		<p>In this tutorial we will utilize {chocolatey()} to install and manage our Tools of the Trade applications 
			including Google Chrome, Firefox, Git, Python, Visual Studio Code, and the Python VSCode extension.</p>

		<p>Steps:</p>
		<ol>
			<li>Install {chocolatey()}</li><pre></pre>
			<li>Install Google Chrome:
			<pre><code>
				choco install googlechrome --ignore-checksums -y
			</code></pre></li>
			<li>Install Firefox, Git, Python, Visual Studio Code, and the Python VSCode extension:
			<pre><code>
				choco install firefox git python vscode vscode-python -y
			</code></pre></li>
			<li>Check everything that has been successfully installed:
			<pre><code>
				choco list
			</code></pre></li>
			<li>Upgrade all {chocolatey()} installed applications at any time:
			<pre><code>
				choco upgrade all
			</code></pre></li>
			<li>Review {chocolateyPackages()} to find additional needed applications</li><pre></pre>
		</ol>
	</div> )
}
export const toolsOfTheTradeWithChocolatey = { 'name':toolsOfTheTradeWithChocolateyName, 'route':toolsOfTheTradeWithChocolateyRoute, 'render':toolsOfTheTradeWithChocolateyRender }


// <p>The following video demonstrates the steps outlined above (~10 minutes).</p>
// <ReactPlayer url={toolsOfTheTradeWithChocolateyVideoURL} controls={true} width={1024} height={576} />*/}


// MERNA Client Tutorial
const MERNaClientName = 'MERNa Client Tutorial'
const MernaClientRoute = 'merna-client'
const MernaClientVideoURL = 'https://pithub.blob.core.windows.net/nvm4zqwm/yqsct11b-merna-client.mp4'
export const MERNaClientRender = () => {
	const template = () => { return externalLink('GitHub template', "https://github.com/EricPogueExampleCode-Web/merna-static-on-azure-2024") }
	const tutorial = () => { return internalLink('Tutorial', `${tutorialRoutePrefix}${MernaClientRoute}` )}
	const azurePortal = () => { return externalLink('Azure Portal', "https://portal.azure.com/") }
	
	return ( <div>
		<h4>{MERNaClientName}</h4>

		<p>In this tutorial we will implement a client website for a MERNa application. The client website will
		utilize GitHub for managing source code connected to an Azure static website for hosting.</p>

		<p>Steps:</p>
		<ol>
			<li>Open a web browser with tabs for this {tutorial()}, {GitHub()} , and the {azurePortal()} Azure</li>
			<li>Log into {GitHub()} and the {azurePortal()}</li>
			<li>Open a tab to the {template()} we will be using</li>
			<li>Utilize the template to create a new GitHub repository</li>
			<li>Create a Azure static website and connect it to the GitHub repository you created</li>  
			<li>Make a small change to the website to verify the deployment pipeline</li>
		</ol>

		<p>The following video demonstrates the steps outlined above (~10 minutes).</p>
		<ReactPlayer url={MernaClientVideoURL} controls={true} width={1024} height={576} />
	</div> )
}
const MERNaClient = { 'name':MERNaClientName, 'route':MernaClientRoute, 'render':MERNaClientRender } 

// MERNA Server Tutorial
const MERNaServerName = 'MERNa Server Tutorial'
const MernaServerRoute = 'merna-server'
const MernaServerVideoURL = 'https://pithub.blob.core.windows.net/nvm4zqwm/yqsct11b-merna-server.mp4'
export const MERNaServerRender = () => {
	const template = () => { return externalLink('GitHub template', "https://github.com/EricPogueExampleCode-Web/merna-node-and-express-on-azure-2024") }
	const tutorial = () => { return internalLink('Tutorial', `${tutorialRoutePrefix}${MernaServerRoute}` )}
	const azurePortal = () => { return externalLink('Azure Portal', "https://portal.azure.com/") }
	
	return ( <div>
		<h4>{MERNaServerName}</h4>

		<p>In this tutorial we will implement a server website for a MERNa application. The server website will
		utilize GitHub for managing source code connected to an Azure Node.js (and Express) website for hosting.</p>

		<p>Steps:</p>
		<ol>
			<li>Open a web browser with tabs for this {tutorial()}, {GitHub()} , and the {azurePortal()} Azure</li>
			<li>Log into {GitHub()} and the {azurePortal()}</li>
			<li>Open a tab to the {template()} we will be using</li>
			<li>Utilize the template to create a new GitHub repository</li>
			<li>Create a Azure Node.js (and Express) website and connect it to the GitHub repository you created</li>  
			<li>Make a small change to the website to verify the deployment pipeline</li>
		</ol>

		<p>The following video demonstrates the steps outlined above (~10 minutes).</p>
		<ReactPlayer url={MernaServerVideoURL} controls={true} width={1024} height={576} />
	</div> )
}
const MERNaServer = { 'name':MERNaServerName, 'route':MernaServerRoute, 'render':MERNaServerRender } 

// MERNA Client and Server Integration Tutorial
const MERNaClientAndServerIntegrationName = 'MERNa Client and Server Integration Tutorial'
const MernaClientAndServerIntegrationRoute = 'merna-client-and-server-integration'
const MernaClientAndServerIntegrationVideoURL = 'https://pithub.blob.core.windows.net/nvm4zqwm/yqsct11b-merna-integration.mp4'
export const MERNaClientAndServerIntegrationRender = () => {
	const tutorial = () => { return internalLink('Tutorial', `${tutorialRoutePrefix}${MernaClientAndServerIntegrationRoute}` )}
	
	return ( <div>
		<h4>{MERNaClientAndServerIntegrationName}</h4>

		<p>Now that we have successfully implemented the MERNa client and server websites, we will integrate them. The 
		integration takes the form of “configuring” the MERNa client so that it accesses the MERNa server web service
		APIs.</p>

		<p>Steps:</p>
		<ol>
			<li>Open a web browser with tabs for this {tutorial()}, your MERNa Client, and your MERNa Server</li>
			<li>“Configure” your MERNa Client to access the APIs of your MERNa Server</li>
			<li>Verify that the remote APIs are working</li>
		</ol>

		<p>The following video demonstrates the steps outlined above (~5 minutes).</p>
		<ReactPlayer url={MernaClientAndServerIntegrationVideoURL} controls={true} width={1024} height={576} />
	</div> )
}
const MERNaClientAndServerIntegration = { 'name':MERNaClientAndServerIntegrationName, 'route':MernaClientAndServerIntegrationRoute, 'render':MERNaClientAndServerIntegrationRender }

// GitHub Pages
const GitHubPagesName = 'GitHub Pages Tutorial'
const GitHubPagesRoute = 'github-pages'
const GitHubPagesVideoURL = 'https://pithub.blob.core.windows.net/nvm4zqwm/t636n0yb-github-pages.mp4'
export const GitHubPagesRender = () => {
	const tutorial = () => { return internalLink('Tutorial', `${tutorialRoutePrefix}${GitHubPagesRoute}` )}
	const template = () => { return externalLink('GitHub template', "https://github.com/EricPogueExampleCode-Web/github-pages-hello-world-template.git") }
	
	return ( <div>
		<h4>{GitHubPagesName}</h4>

		<p>In this tutorial we will implement a static website for a MERNa application. The static website will
		utilize GitHub for managing source code connected to a GitHub Pages website for hosting.</p>

		<p>Steps:</p>
		<ol>
			<li>Open a web browser with tabs for this {tutorial()} and {GitHub()}</li>
			<li>Log into {GitHub()}</li>
			<li>Open a tab to the {template()} we will be using</li>
			<li>Utilize the template to create a new GitHub repository</li>
			<li>Create a GitHub Pages website</li>  
			<li>Make a small change to the website to verify the deployment pipeline</li>
		</ol>

		<p>The following video demonstrates the steps outlined above (~10 minutes).</p>
		<ReactPlayer url={GitHubPagesVideoURL} controls={true} width={1024} height={576} />
	</div> )
}
const GitHubPages = { 'name':GitHubPagesName, 'route':GitHubPagesRoute, 'render':GitHubPagesRender }
// End of MERNa Tutorials

const tutorialList = [ toolsOfTheTradeWithChocolatey, GitHubPages, MERNaClient, MERNaServer, MERNaClientAndServerIntegration, tutorialIndex ]

// MERNa Client, Server, and AJAX Tutorial slides.
/*
const gitAzureStaticDeck = () => { 
	const client = () => {
		return orderedListSlide(
			'MERNa Client Website Tutorial', 

			`In this tutorial we will implement a client website for a MERNa application. The client website will
			utilize GitHub for managing source code connected to an Azure static website for hosting.`, [

			'Open a web browser with tabs for the Tutorial, GitHub, and Azure',
			'Log into GitHub and Azure',
			'Open a tab to “https://github.com/EricPogueExampleCode-Web/merna-static-on-azure-2024”',
			'Use the template to create a new GitHub repository',
			'Create a static website in Azure that is linked to the GitHub repository',  
			'Make a small change to the website to verify the deployment pipeline' ] )
	}

	const server = () => {
		return orderedListSlide(
			'MERNa Server Website Tutorial', 

			`In this tutorial we will implement a server website for a MERNa application. The server website will
			utilize GitHub for managing source code connected to an Azure Node.js (and Express) website for hosting.`, [

			'Open a web browser with tabs for the Tutorial, GitHub, and Azure',
			'Log into GitHub and Azure',
			'Open a tab to “https://github.com/EricPogueExampleCode-Web/merna-node-and-express-on-azure-2024”',
			'Use the template to create a new GitHub repository',
			'Create a Node.js website in Azure that is linked to the GitHub repository',  
			'Make a small change to the website to verify the deployment pipeline' ] )
	}

	const ajax = () => {
		return orderedListSlide(
			'MERNa Client and Server Integration Tutorial', 

			`Now that we have successfully implemented the MERNa client and server websites, we will integrate them. The 
			integration takes the form of “configuring” the MERNa client so that it accesses the MERNa server web service
			APIs.`, [

			'Open a web browser with tabs for this Tutorial, your MERNa Client, and your MERNa Server',
			'“Configure” your MERNa Client to access the APIs of your MERNa Server',
			'Verify that the remote APIs are working' ] )
	}
	return [ client, server, ajax ] 
}
const gitAzureStatic = { 'name':'MERNa Client Website Tutorial', 'route':'merna-client-website', 'deck':gitAzureStaticDeck } 
*/



/*

const MONGODB_ATLAS_MOVIE_CRUD_ROUTE = 'mongo-crud'
const MongoDBAtlasMovieCRUD = () => {
	const agenda = () => {
		return orderedListSlide(
			'MongoDB Atlas Movie CRUD', 
			'In this tutorial we will utilize MongoDB Atlas, Github, and JavaScript to implement a database of movies by:', [
			'Creating a GitHub repository that includes JavaScript Create, Read, Update, and Delete scripts',  
			'Creating a MongoDB Atlas Organization, Project, and Database Cluster', 
			'Creating a Database User & Password and granting network access to the Database Cluster',
			'Utilizing Node.js to install the ‘mongodb’ driver and to execute JavaScript command line scripts',
			'Utilizing Node.js and the JavaScript Create script to create a Database, Collection, and movie Document',
			'Utilizing Node.js and JavaScript to Read, Update, and Delete movies (CRUD)',
			'Cleaning up by deleting the MongoDB Atlas Database Cluster, Project, Organization, and the GitHub repository'])
	}

	return [ agenda ]
}

const MOVIE_CRUD_LITE = 'movie-crud-lite'
const MovieCRUDLite = () => {
	const agenda = () => {
		return orderedListSlide(
			'MovieCRUDLite', 
			`In this tutorial we will implement a Movie Review Website utilizing GitHub, Microsoft Azure, MongoDB 
			Atlas, Node.js and the “mongoose” and “body-parser” JavaScript libraries by:`, [
			'Creating a GitHub repository using the “https://github.com/EricJPogue/node-js-express-and-azure-template”',  
			'Implementing Read using “mongoose”', 
			'Implementing Create using “mongoose” and “body-parser”',
			'Cleaning up by testing and reviewing what is left to be completed'])
	}

	return [ agenda, agenda ]
}
	*/